import React, { useState } from "react";
import { useSaveQuestionChangesCheck } from "../../utils/useSaveQuestionChangesModal";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import { SaveQuestionChanges } from "../../SaveQuestionChanges";
import { BOOKING_QUESTION_SAVE_CHANGES_TYPE } from "../../constants/SaveQuestionChanges.constants";

export const SaveQuestionChangesModal = withComponentLibraryTheme(() => {
  const { isOpen, close, confirm } = useSaveQuestionChangesCheck({});
  const [selected, setSelected] = useState(
    BOOKING_QUESTION_SAVE_CHANGES_TYPE.APPLY_TO_NEW
  );

  const handleConfirm = () => {
    return confirm(selected);
  };

  // Reset State when modal closes
  const onClose = () => {
    setSelected(BOOKING_QUESTION_SAVE_CHANGES_TYPE.APPLY_TO_NEW);
    close();
  };

  return (
    <ExlyModal
      title="Please confirm changes"
      header="Please confirm changes"
      primaryBtnText="Save Changes"
      secondaryBtnText="Cancel"
      onSecondaryBtnClick={close}
      onPrimaryBtnClick={handleConfirm}
      open={isOpen}
      onClose={onClose}
      padded={false}
      showSecondaryBtn
      modal_props={{
        modalPaperClassName: "tw-w-[434px]",
        secondaryBtnClassName: "tw-text-[#493ab1] !tw-important",
      }}
      mobile_modal_props={{
        secondaryAction: {
          label: "Cancel",
          onClick: close,
          className: "tw-text-[#493ab1]",
        },
      }}
    >
      <div className="tw-flex tw-flex-col !tw-p-0">
        <SaveQuestionChanges
          selected={selected}
          onSelect={(value) => setSelected(value)}
        />
      </div>
    </ExlyModal>
  );
});
